import React from 'react';
import logo from './logo.svg';
import './index.css';
import { Routes, Route, Link } from 'react-router-dom';

function Main() {
  console.log('urlurl', process.env.REACT_APP_BACKEND_URL);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <Link className="App-link" to="/second">
          To Second
        </Link>
      </header>
    </div>
  );
}

export default Main;
